export const SoldRibbon = ({ label, testid = "sold-ribbon" }) => (
  <span
    data-testid={testid}
    className="pointer-events-none absolute -left-10 top-6 z-20 w-44 -rotate-45 bg-bronze py-1.5 text-center text-[10px] font-semibold uppercase tracking-[0.25em] text-ivory"
  >
    {label}
  </span>
);
